import ContactHero from '../components/Contact/ContactHero';
import ContactForm from '../components/Contact/ContactForm';
import FAQSection from '../components/Contact/FAQSection';
import MapLocation from '../components/Contact/MapLocation';
import SEO, { SITE_URL } from '../components/SEO';

const Contact = () => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: 'Contact Tantika Crafts',
    url: `${SITE_URL}/contact`,
    description:
      'Get in touch with Tantika Crafts for enquiries about handmade artisan products, custom orders, partnerships, or artisan applications.',
    mainEntity: {
      '@type': 'Organization',
      name: 'Tantika Crafts',
      email: 'tantikacustomercare@outlook.com',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'IN',
      },
    },
  };

  return (
    <div>
      <SEO
        title="Contact Us - Support, Orders & Artisan Enquiries"
        description="Contact Tantika Crafts for help with orders, product enquiries, custom handmade requests, partnerships, and artisan applications. We typically respond within 24 hours."
        keywords="contact tantika crafts, artisan support, order help, handmade product enquiry, custom craft orders, become an artisan, partnerships"
        url="/contact"
        type="website"
        jsonLd={jsonLd}
      />
      <ContactHero />
      <ContactForm />
      <FAQSection />
      <MapLocation />
    </div>
  );
};

export default Contact;
